import {
	ChangeDetectorRef,
	Component,
	EventEmitter,
	Input,
	OnChanges, OnDestroy,
	OnInit,
	Output,
	SimpleChanges,
	ViewChild
} from '@angular/core';
import {
	NgxStripeModule,
	StripeCardComponent,
	StripeCardCvcComponent,
	StripeCardExpiryComponent,
	StripeCardNumberComponent,
	StripeService
} from 'ngx-stripe';
import {
	PaymentIntent,
	StripeCardElementOptions,
	StripeElementsOptions,
	StripeError
} from '@stripe/stripe-js';
import { FormGroup, FormBuilder, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { Subject, throwError } from 'rxjs';
import { takeUntil, switchMap, catchError } from 'rxjs/operators';
import { PaymentIntentDto, StripePaymentIntentResponse, FinishPaymentRequest } from 'src/app/api/models';
import { UserTowerGroupsApiService, UserBookingsApiService, UserStripePaymentsApiService } from 'src/app/api/services';
import { ICustomControl } from 'src/shared/models/form.model';
import { PaymentInfo, CustomerPaymentMethod, PaymentIds, PaypalActionObj, PayPalAction, CardConfirmResponse, PaymentMethodEnum } from 'src/shared/models/payment.model';
import { BookingHelperService } from 'src/shared/services/helpers/booking-helper.service';
import { CustomSpinnerService } from 'src/shared/services/helpers/custom-spinner.service';
import { EventsService } from 'src/shared/services/helpers/events.service';
import { HelperService } from 'src/shared/services/helpers/helper.service';
import { PaymentsHelperService } from 'src/shared/services/helpers/payments-helper.service';
import { FormService } from 'src/shared/shared-forms/form.service';
import { NgIf, NgSwitch, NgSwitchCase } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { PayWithPayPalComponent } from "../pay-with-wrapper/components/pay-with-paypal/pay-with-paypal.component";
import { IonButton, IonItem, IonAvatar, IonLabel } from "@ionic/angular/standalone";

@Component({
	selector: 'vl-add-new-credit-card',
	templateUrl: './add-new-credit-card.component.html',
	styleUrls: ['./add-new-credit-card.component.scss'],
	imports: [IonLabel, IonAvatar, IonItem, NgSwitchCase, FormsModule, NgSwitch, IonButton, NgxStripeModule, NgIf, TranslatePipe, ReactiveFormsModule, PayWithPayPalComponent],
})
export class AddNewCreditCardComponent implements OnInit, OnChanges, OnDestroy {
	@ViewChild(StripeCardComponent) card: StripeCardComponent;
	@ViewChild(StripeCardNumberComponent) cardNumber: StripeCardNumberComponent;
	@ViewChild(StripeCardCvcComponent) cvc: StripeCardCvcComponent;
	@ViewChild(StripeCardExpiryComponent) cardExpiration: StripeCardExpiryComponent;
	@Input() toPayCardInfo: PaymentInfo;
	@Input() paymentType: { type: 'new-card' | 'saved-card', card: CustomerPaymentMethod };
	@Output() onSuccess: EventEmitter<any> = new EventEmitter<any>();
	@Output() onError: EventEmitter<any> = new EventEmitter<any>();
	@Output() back: EventEmitter<any> = new EventEmitter<any>();
	public controls: ICustomControl[];
	public submitted = false;
	private _prefix = 'payment.form';
	private notifier: Subject<any> = new Subject<any>();

	isReady = false;
	isInited = false;
	isCardInfoValid = false;
	saveForFuturePayments = false;
	cardValidation = {
		cvc: false,
		cardNumber: false,
		expirationDate: false,
		zip: true
	};
	payEnabled = false;
	paymentActive = false;
	paymentEnums = PaymentMethodEnum;


	elementsOptions: StripeElementsOptions = {
		locale: 'en',
	};

	cardOptions: StripeCardElementOptions = {
		style: {
			base: {
				color: '#32325D',
				fontWeight: 500,
				fontFamily: 'Inter UI, Open Sans, Segoe UI, sans-serif',
				fontSize: '16px',
				fontSmoothing: 'antialiased',
				lineHeight: "32px",

				'::placeholder': {
					// color: "#CFD7DF"
					color: 'grey'
				}
			},
			invalid: {
				color: '#E25950'
			}
		}
	};

	paymentForm: FormGroup;
	paymentIds: PaymentIds;

	constructor(private _formService: FormService,
				private _formBuilder: FormBuilder,
				private stripeService: StripeService,
				private helpService: HelperService,
				private bookingHelper: BookingHelperService,
				private groupsApiService: UserTowerGroupsApiService,
				private spinner: CustomSpinnerService,
				private eventsService: EventsService,
				private bookingService: UserBookingsApiService,
				private stripePaymentService: UserStripePaymentsApiService,
				private paymentHelper: PaymentsHelperService,
				private cd: ChangeDetectorRef,
				private router: Router) {
		this.paymentHelper.$stripeReady
			.pipe(
				takeUntil(this.notifier)
			)
			.subscribe((key) => {
				this.stripeService.setKey(key);
				setTimeout(() => {
					this.isReady = true;
				}, 100);
			});
	}

	ngOnInit(): void {
		this.controls = this._formService.paymentControls;
		this.createFG();
		this.isInited = true;
	}

	public ngOnChanges(changes: SimpleChanges): void {
		if (changes && changes['paymentType'] && changes['paymentType'].currentValue) {
			this.checkPayEnabled(false);
		}
	}

	setToken(token) {
		this.stripeService.setKey(token);
		this.isReady = true;
		this.isReady = true;
		this.spinner.hide();
	}


	public ngOnDestroy(): void {
		this.notifier.next('');
		this.notifier.complete();
	}

	private createFG() {
		this.controls.forEach(c => c.title = c.label);
		this.paymentForm = this._formBuilder.group(this._formService.configureControls(this.controls, this._prefix));
		this.paymentForm.valueChanges.subscribe(r => {
			if (this.submitted) {
				this.submitted = false;
			}
		});

		// this.paymentForm.get('address_zip').valueChanges.subscribe((r: string) => {
		// 	this.cardValidation.zip = true;
		// 	this.checkPayEnabled();
		// });

		this.controls.find(c => c.id === 'address_country').selectData = this.helpService.countries;
	}

	private createPaymentIntent() {
		if (this.toPayCardInfo.type === 'pay-per-use') {
			return this.stripePaymentService.createBookingPaymentIntent({
				body: {
					method: this.paymentType.card.type,
					bookingId: this.toPayCardInfo.bookingId,
					freeHours: this.toPayCardInfo.freeHoursUsed
				}
			});
		} else if (this.toPayCardInfo.type === 'subscription') {
			return this.stripePaymentService.createSubscriptionPaymentIntent({
				body: {
					method: this.paymentType.card.type,
					towerGroupId: this.toPayCardInfo.groupId,
					onDateTime: new Date(this.toPayCardInfo.subscriptionStartDate).toISOString()
				}
			});
		}
	}

	toggleSaveForFuture() {
		const current = this.paymentForm.get('saveForFuturePayments').value;
		this.paymentForm.get('saveForFuturePayments').setValue(!current);
	}

	change(e, type: 'cvc' | 'cardNumber' | 'expirationDate') {
		this.cardValidation[type] = e.complete;

		this.checkPayEnabled();
	}

	onSubmit() {
		this.doPayment();
	}

	doPayment() {
		this.spinner.show(false).then(() => {
			this.bookingHelper.towerReadyToAction(this.toPayCardInfo.type, (valid) => {
				if(valid) {
					this.createPaymentIntent()
						.pipe(
							switchMap((pi) => {
								this.handlePaymentIds(pi);
								this.paymentActive = true;
								return this.getConfirmMethod(pi);
							}),
							catchError((e) => {
								return this.handlePaymentError(e);
							})
						).subscribe((result: CardConfirmResponse | PaymentIntentDto) => {

							switch (this.paymentType.card.type) {
								case PaymentMethodEnum.STRIPE_GIROPAY:
									this.handleGiropayConfirm((result as PaymentIntentDto).clientSecret);
									break;
								case PaymentMethodEnum.STRIPE_CARD:
									result = result as {
										paymentIntent?: PaymentIntent;
										error?: StripeError
									};
									if (result.error) {
										// The payment failed -- ask your customer for a new payment method.
										this.onError.emit();
										this.spinner.hide();
										this.paymentActive = false;
									} else {
										// The payment has succeeded.
										this.paymentActive = false;
										this.handlePaymentSuccess();
									}
									break;
							}
						}
					);
				}
			}, this.toPayCardInfo.bookingId, this.toPayCardInfo.groupId, this.toPayCardInfo.subscriptionStartDate);
		});
	}

	private handlePaymentError(e) {
		console.log('error', e);
		this.spinner.hide();
		if ((e.error === 'Internal Server Error' && e.path === '/api/user/payment/subscription') || e.status === 400) {
			this.onError.emit();
		}
		return throwError(e);
	}

	private async handlePaymentIds(pi: StripePaymentIntentResponse) {
		this.paymentIds = {
			main: null,
			freeHours: null
		};
		Object.keys(pi.paymentsToMethod).forEach((k: any) => {
			console.log(k, pi.paymentsToMethod[k]);
			if (pi.paymentsToMethod[k] === 'FREE_HOURS') {
				this.paymentIds.freeHours = Number(k);
			} else {
				this.paymentIds.main = Number(k);
			}
		});
	}

	private handleGiropayConfirm(clientSecret) {
		this.stripeService.retrievePaymentIntent(clientSecret).subscribe(async p => {
			await this.paymentHelper.openPaymentWindow(p.paymentIntent.next_action.redirect_to_url.url, (d) => {
				if (d.type === 'success') {
					this.router.navigateByUrl('/payment' + d.queryParams);
				}
			});
		});
	}

	private getConfirmMethod(pi: StripePaymentIntentResponse) {
		let paymentParams = {};
		paymentParams = this.handleParams(paymentParams);
		return this.paymentType.card.type === PaymentMethodEnum.STRIPE_CARD
			? this.stripeService.confirmCardPayment(
				pi.paymentIntent.clientSecret,
				paymentParams,
				{ handleActions: true })
			: null;
			// this.stripePaymentService.confirmGiropay(
			// 	{
			// 		body: {
			// 			returnUrl: document.location.origin + '/app/home',
			// 			fullName: this.paymentForm.value.name,
			// 			paymentId: this.paymentIds.main
			// 		}
			// 	}
			// );
	}

	private handleParams(paymentParams: {}) {
		if (this.paymentType.type === 'new-card' && this.paymentType.card.type === PaymentMethodEnum.STRIPE_CARD) {
			paymentParams = Object.assign(paymentParams, {
				payment_method: {
					card: this.cardNumber.element
				}
			});
			// this.analyticsService.logEvent(AnalyticsEvents.AddNewPaymentMethod, PaymentMethodEnum.STRIPE_CARD);
		} else if (this.paymentType.type === 'saved-card') {
			paymentParams = Object.assign(paymentParams, {
				payment_method: this.paymentType.card.id
			});
		}

		// if (this.paymentType.card.type === PaymentMethodEnum.STRIPE_GIROPAY) {
		// 	paymentParams = Object.assign(paymentParams, {
		// 		return_url: document.location.origin + '/app/home',
		// 		payment_method: {
		// 			billing_details: {
		// 				name: 'Jenny Rosen'
		// 			}
		// 		},
		// 	});
		// }

		if (this.saveForFuturePayments) {
			paymentParams = Object.assign(paymentParams, {
				setup_future_usage: 'off_session',
			});
		}
		return paymentParams;
	}

	handlePaymentSuccess() {
		let body: FinishPaymentRequest = {
			paymentId: this.paymentIds.main
		};

		if (this.paymentIds.freeHours) {
			body = {
				...body,
				...{ freeHoursPaymentId: this.paymentIds.freeHours }
			};
		}
		this.stripePaymentService.finishPayment({
			body
		}).subscribe(() => {
			this.analyticsCompletePayment();
			if (this.toPayCardInfo.type === 'pay-per-use') {
				this.terminateBooking();
			} else {
				this.createSubscription(this.paymentIds.main);
			}
		});
	}

	private analyticsCompletePayment() {
		const dataForAnalytics = { ...this.toPayCardInfo };
		dataForAnalytics.method = PaymentMethodEnum.STRIPE_CARD;
		// this.analyticsService.logEvent(AnalyticsEvents.CompletePayment, dataForAnalytics);
	}

	cardChange(ev) {
		this.isCardInfoValid = ev.complete;
	}

	handlePaypalAction(ppAction: PaypalActionObj) {
		switch (ppAction.action) {
			case PayPalAction.Report:
				this.terminateBooking();
				break;
			case PayPalAction.Cancel:
				break;
			case PayPalAction.Error:
				this.onError.emit();
				break;
			case PayPalAction.Subscription:
				this.createSubscription(ppAction.props.paymentIds.main, true);
				break;
		}
	}

	terminateBooking() {
		const bookingId = Number(this.toPayCardInfo.bookingId);
		this.bookingService.terminateBooking({
			bookingId,
		}).subscribe(() => {
			// this.analyticsService.logEvent(
			// 	AnalyticsEvents.TerminateBooking,
			// 	this.toPayCardInfo.booking);
			this.eventsService.refreshBookings();
			this.bookingHelper.handleTerminateBooking(bookingId);
			this.paymentActive = false;
			this.onSuccess.emit();
			this.spinner.hide();
		});
	}

	createSubscription(paymentId, paypal = false) {
		const $subscribeSubsciption = this.groupsApiService.subscribe({
			id: this.toPayCardInfo.groupId,
			body: {
				paymentId,
				startDate: new Date(this.toPayCardInfo.subscriptionStartDate || new Date()).toISOString()
			}
		});

		const handleResp = (s) => {
			// this.analyticsService.logEvent(AnalyticsEvents.CreateSubscription, s);
			this.eventsService.refreshBookings();
			this.eventsService.updateSubs();
			this.paymentActive = false;
			this.onSuccess.emit();
			this.spinner.hide();
		};

		$subscribeSubsciption.subscribe((s) => {
			handleResp(s);
		});
	}

	goBack() {
		if (this.paymentType.type === 'new-card' && this.paymentType.card.type === PaymentMethodEnum.STRIPE_CARD) {
			this.cardNumber.element.clear();
			this.cvc.element.clear();
			this.cardExpiration.element.clear();
			this.paymentForm.reset();
		}

		this.back.emit();
	}

	checkPayEnabled(needDetection = true) {
		if (this.paymentType.type === 'saved-card' || this.paymentType.card.type === PaymentMethodEnum.STRIPE_GIROPAY) {
			return this.payEnabled = true;
		}
		this.payEnabled = this.cardValidation.cardNumber
			&& this.cardValidation.cvc
			&& this.cardValidation.expirationDate;

		if (needDetection) {
			this.cd.checkNoChanges();
		}
	}
}


